/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as TwoFactorSetupRouteImport } from './routes/two-factor-setup'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppItemKeyRouteImport } from './routes/_app/$itemKey'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppFeedbackRouteImport } from './routes/_app/feedback'
import { Route as AppInboxRouteImport } from './routes/_app/inbox'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppTriageRouteImport } from './routes/_app/triage'
import { Route as DevDesignRouteImport } from './routes/dev/design'
import { Route as FTokenRouteImport } from './routes/f.$token'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as ResetPasswordTokenRouteImport } from './routes/reset-password.$token'
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin.index'
import { Route as AppAdminAccessRouteImport } from './routes/_app/admin.access'
import { Route as AppAdminAuditRouteImport } from './routes/_app/admin.audit'
import { Route as AppAdminAuthenticationRouteImport } from './routes/_app/admin.authentication'
import { Route as AppAdminFieldsRouteImport } from './routes/_app/admin.fields'
import { Route as AppAdminGithubRouteImport } from './routes/_app/admin.github'
import { Route as AppAdminGroupsRouteImport } from './routes/_app/admin.groups'
import { Route as AppAdminInstanceRouteImport } from './routes/_app/admin.instance'
import { Route as AppAdminInvitesRouteImport } from './routes/_app/admin.invites'
import { Route as AppAdminLicenseRouteImport } from './routes/_app/admin.license'
import { Route as AppAdminRolesRouteImport } from './routes/_app/admin.roles'
import { Route as AppAdminSystemRouteImport } from './routes/_app/admin.system'
import { Route as AppAdminTranslationRouteImport } from './routes/_app/admin.translation'
import { Route as AppAdminTypesRouteImport } from './routes/_app/admin.types'
import { Route as AppAdminUsersRouteImport } from './routes/_app/admin.users'
import { Route as AppAdminWebhooksRouteImport } from './routes/_app/admin.webhooks'
import { Route as AppDevPerfRouteImport } from './routes/_app/dev.perf'
import { Route as AppNotesIndexRouteImport } from './routes/_app/notes.index'
import { Route as AppPProductKeyRouteImport } from './routes/_app/p/$productKey'
import { Route as AppSSpaceKeyRouteImport } from './routes/_app/s/$spaceKey'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings.index'
import { Route as AppSettingsClaudeRouteImport } from './routes/_app/settings.claude'
import { Route as AppSettingsNotificationsRouteImport } from './routes/_app/settings.notifications'
import { Route as AppSettingsSecurityRouteImport } from './routes/_app/settings.security'
import { Route as AppSettingsTokensRouteImport } from './routes/_app/settings.tokens'
import { Route as AppAdminWorkflowsIndexRouteImport } from './routes/_app/admin.workflows.index'
import { Route as AppAdminWorkflowsWorkflowIdRouteImport } from './routes/_app/admin.workflows.$workflowId'
import { Route as AppNotesRefChar123SlugChar125RouteImport } from './routes/_app/notes.$ref.{-$slug}'
import { Route as AppPProductKeyIndexRouteImport } from './routes/_app/p/$productKey/index'
import { Route as AppPProductKeyBoardRouteImport } from './routes/_app/p/$productKey/board'
import { Route as AppPProductKeyFieldsRouteImport } from './routes/_app/p/$productKey/fields'
import { Route as AppPProductKeyListRouteImport } from './routes/_app/p/$productKey/list'
import { Route as AppPProductKeyNextUpRouteImport } from './routes/_app/p/$productKey/next-up'
import { Route as AppPProductKeyTimelineRouteImport } from './routes/_app/p/$productKey/timeline'
import { Route as AppPProductKeyTrashRouteImport } from './routes/_app/p/$productKey/trash'
import { Route as AppPProductKeyViewsRouteImport } from './routes/_app/p/$productKey/views'
import { Route as AppPProductKeyMilestonesIndexRouteImport } from './routes/_app/p/$productKey/milestones.index'
import { Route as AppPProductKeyMilestonesMilestoneIdRouteImport } from './routes/_app/p/$productKey/milestones.$milestoneId'
import { Route as AppPProductKeyNotesIndexRouteImport } from './routes/_app/p/$productKey/notes.index'
import { Route as AppPProductKeyNotesRefChar123SlugChar125RouteImport } from './routes/_app/p/$productKey/notes.$ref.{-$slug}'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const TwoFactorSetupRoute = TwoFactorSetupRouteImport.update({
  id: '/two-factor-setup',
  path: '/two-factor-setup',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppItemKeyRoute = AppItemKeyRouteImport.update({
  id: '/$itemKey',
  path: '/$itemKey',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppFeedbackRoute = AppFeedbackRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxRoute = AppInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppTriageRoute = AppTriageRouteImport.update({
  id: '/triage',
  path: '/triage',
  getParentRoute: () => AppRoute,
} as any)
const DevDesignRoute = DevDesignRouteImport.update({
  id: '/dev/design',
  path: '/dev/design',
  getParentRoute: () => rootRouteImport,
} as any)
const FTokenRoute = FTokenRouteImport.update({
  id: '/f/$token',
  path: '/f/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordTokenRoute = ResetPasswordTokenRouteImport.update({
  id: '/reset-password/$token',
  path: '/reset-password/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAccessRoute = AppAdminAccessRouteImport.update({
  id: '/access',
  path: '/access',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAuditRoute = AppAdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminAuthenticationRoute = AppAdminAuthenticationRouteImport.update({
  id: '/authentication',
  path: '/authentication',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminFieldsRoute = AppAdminFieldsRouteImport.update({
  id: '/fields',
  path: '/fields',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminGithubRoute = AppAdminGithubRouteImport.update({
  id: '/github',
  path: '/github',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminGroupsRoute = AppAdminGroupsRouteImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminInstanceRoute = AppAdminInstanceRouteImport.update({
  id: '/instance',
  path: '/instance',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminInvitesRoute = AppAdminInvitesRouteImport.update({
  id: '/invites',
  path: '/invites',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminLicenseRoute = AppAdminLicenseRouteImport.update({
  id: '/license',
  path: '/license',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminRolesRoute = AppAdminRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminSystemRoute = AppAdminSystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminTranslationRoute = AppAdminTranslationRouteImport.update({
  id: '/translation',
  path: '/translation',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminTypesRoute = AppAdminTypesRouteImport.update({
  id: '/types',
  path: '/types',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminUsersRoute = AppAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminWebhooksRoute = AppAdminWebhooksRouteImport.update({
  id: '/webhooks',
  path: '/webhooks',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppDevPerfRoute = AppDevPerfRouteImport.update({
  id: '/dev/perf',
  path: '/dev/perf',
  getParentRoute: () => AppRoute,
} as any)
const AppNotesIndexRoute = AppNotesIndexRouteImport.update({
  id: '/notes/',
  path: '/notes/',
  getParentRoute: () => AppRoute,
} as any)
const AppPProductKeyRoute = AppPProductKeyRouteImport.update({
  id: '/p/$productKey',
  path: '/p/$productKey',
  getParentRoute: () => AppRoute,
} as any)
const AppSSpaceKeyRoute = AppSSpaceKeyRouteImport.update({
  id: '/s/$spaceKey',
  path: '/s/$spaceKey',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsClaudeRoute = AppSettingsClaudeRouteImport.update({
  id: '/claude',
  path: '/claude',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsNotificationsRoute =
  AppSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsSecurityRoute = AppSettingsSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsTokensRoute = AppSettingsTokensRouteImport.update({
  id: '/tokens',
  path: '/tokens',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppAdminWorkflowsIndexRoute = AppAdminWorkflowsIndexRouteImport.update({
  id: '/workflows/',
  path: '/workflows/',
  getParentRoute: () => AppAdminRoute,
} as any)
const AppAdminWorkflowsWorkflowIdRoute =
  AppAdminWorkflowsWorkflowIdRouteImport.update({
    id: '/workflows/$workflowId',
    path: '/workflows/$workflowId',
    getParentRoute: () => AppAdminRoute,
  } as any)
const AppNotesRefChar123SlugChar125Route =
  AppNotesRefChar123SlugChar125RouteImport.update({
    id: '/notes/$ref/{-$slug}',
    path: '/notes/$ref/{-$slug}',
    getParentRoute: () => AppRoute,
  } as any)
const AppPProductKeyIndexRoute = AppPProductKeyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPProductKeyRoute,
} as any)
const AppPProductKeyBoardRoute = AppPProductKeyBoardRouteImport.update({
  id: '/board',
  path: '/board',
  getParentRoute: () => AppPProductKeyRoute,
} as any)
const AppPProductKeyFieldsRoute = AppPProductKeyFieldsRouteImport.update({
  id: '/fields',
  path: '/fields',
  getParentRoute: () => AppPProductKeyRoute,
} as any)
const AppPProductKeyListRoute = AppPProductKeyListRouteImport.update({
  id: '/list',
  path: '/list',
  getParentRoute: () => AppPProductKeyRoute,
} as any)
const AppPProductKeyNextUpRoute = AppPProductKeyNextUpRouteImport.update({
  id: '/next-up',
  path: '/next-up',
  getParentRoute: () => AppPProductKeyRoute,
} as any)
const AppPProductKeyTimelineRoute = AppPProductKeyTimelineRouteImport.update({
  id: '/timeline',
  path: '/timeline',
  getParentRoute: () => AppPProductKeyRoute,
} as any)
const AppPProductKeyTrashRoute = AppPProductKeyTrashRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => AppPProductKeyRoute,
} as any)
const AppPProductKeyViewsRoute = AppPProductKeyViewsRouteImport.update({
  id: '/views',
  path: '/views',
  getParentRoute: () => AppPProductKeyRoute,
} as any)
const AppPProductKeyMilestonesIndexRoute =
  AppPProductKeyMilestonesIndexRouteImport.update({
    id: '/milestones/',
    path: '/milestones/',
    getParentRoute: () => AppPProductKeyRoute,
  } as any)
const AppPProductKeyMilestonesMilestoneIdRoute =
  AppPProductKeyMilestonesMilestoneIdRouteImport.update({
    id: '/milestones/$milestoneId',
    path: '/milestones/$milestoneId',
    getParentRoute: () => AppPProductKeyRoute,
  } as any)
const AppPProductKeyNotesIndexRoute =
  AppPProductKeyNotesIndexRouteImport.update({
    id: '/notes/',
    path: '/notes/',
    getParentRoute: () => AppPProductKeyRoute,
  } as any)
const AppPProductKeyNotesRefChar123SlugChar125Route =
  AppPProductKeyNotesRefChar123SlugChar125RouteImport.update({
    id: '/notes/$ref/{-$slug}',
    path: '/notes/$ref/{-$slug}',
    getParentRoute: () => AppPProductKeyRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/setup': typeof SetupRoute
  '/two-factor-setup': typeof TwoFactorSetupRoute
  '/$itemKey': typeof AppItemKeyRoute
  '/admin': typeof AppAdminRouteWithChildren
  '/feedback': typeof AppFeedbackRoute
  '/inbox': typeof AppInboxRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/triage': typeof AppTriageRoute
  '/dev/design': typeof DevDesignRoute
  '/f/$token': typeof FTokenRoute
  '/invite/$token': typeof InviteTokenRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/admin/access': typeof AppAdminAccessRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/authentication': typeof AppAdminAuthenticationRoute
  '/admin/fields': typeof AppAdminFieldsRoute
  '/admin/github': typeof AppAdminGithubRoute
  '/admin/groups': typeof AppAdminGroupsRoute
  '/admin/instance': typeof AppAdminInstanceRoute
  '/admin/invites': typeof AppAdminInvitesRoute
  '/admin/license': typeof AppAdminLicenseRoute
  '/admin/roles': typeof AppAdminRolesRoute
  '/admin/system': typeof AppAdminSystemRoute
  '/admin/translation': typeof AppAdminTranslationRoute
  '/admin/types': typeof AppAdminTypesRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/admin/webhooks': typeof AppAdminWebhooksRoute
  '/dev/perf': typeof AppDevPerfRoute
  '/p/$productKey': typeof AppPProductKeyRouteWithChildren
  '/s/$spaceKey': typeof AppSSpaceKeyRoute
  '/settings/claude': typeof AppSettingsClaudeRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/settings/tokens': typeof AppSettingsTokensRoute
  '/admin/': typeof AppAdminIndexRoute
  '/notes/': typeof AppNotesIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/admin/workflows/$workflowId': typeof AppAdminWorkflowsWorkflowIdRoute
  '/notes/$ref/{-$slug}': typeof AppNotesRefChar123SlugChar125Route
  '/p/$productKey/board': typeof AppPProductKeyBoardRoute
  '/p/$productKey/fields': typeof AppPProductKeyFieldsRoute
  '/p/$productKey/list': typeof AppPProductKeyListRoute
  '/p/$productKey/next-up': typeof AppPProductKeyNextUpRoute
  '/p/$productKey/timeline': typeof AppPProductKeyTimelineRoute
  '/p/$productKey/trash': typeof AppPProductKeyTrashRoute
  '/p/$productKey/views': typeof AppPProductKeyViewsRoute
  '/admin/workflows/': typeof AppAdminWorkflowsIndexRoute
  '/p/$productKey/': typeof AppPProductKeyIndexRoute
  '/p/$productKey/milestones/$milestoneId': typeof AppPProductKeyMilestonesMilestoneIdRoute
  '/p/$productKey/milestones/': typeof AppPProductKeyMilestonesIndexRoute
  '/p/$productKey/notes/': typeof AppPProductKeyNotesIndexRoute
  '/p/$productKey/notes/$ref/{-$slug}': typeof AppPProductKeyNotesRefChar123SlugChar125Route
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/setup': typeof SetupRoute
  '/two-factor-setup': typeof TwoFactorSetupRoute
  '/$itemKey': typeof AppItemKeyRoute
  '/feedback': typeof AppFeedbackRoute
  '/inbox': typeof AppInboxRoute
  '/triage': typeof AppTriageRoute
  '/dev/design': typeof DevDesignRoute
  '/f/$token': typeof FTokenRoute
  '/invite/$token': typeof InviteTokenRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/': typeof AppIndexRoute
  '/admin/access': typeof AppAdminAccessRoute
  '/admin/audit': typeof AppAdminAuditRoute
  '/admin/authentication': typeof AppAdminAuthenticationRoute
  '/admin/fields': typeof AppAdminFieldsRoute
  '/admin/github': typeof AppAdminGithubRoute
  '/admin/groups': typeof AppAdminGroupsRoute
  '/admin/instance': typeof AppAdminInstanceRoute
  '/admin/invites': typeof AppAdminInvitesRoute
  '/admin/license': typeof AppAdminLicenseRoute
  '/admin/roles': typeof AppAdminRolesRoute
  '/admin/system': typeof AppAdminSystemRoute
  '/admin/translation': typeof AppAdminTranslationRoute
  '/admin/types': typeof AppAdminTypesRoute
  '/admin/users': typeof AppAdminUsersRoute
  '/admin/webhooks': typeof AppAdminWebhooksRoute
  '/dev/perf': typeof AppDevPerfRoute
  '/s/$spaceKey': typeof AppSSpaceKeyRoute
  '/settings/claude': typeof AppSettingsClaudeRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/settings/tokens': typeof AppSettingsTokensRoute
  '/admin': typeof AppAdminIndexRoute
  '/notes': typeof AppNotesIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/admin/workflows/$workflowId': typeof AppAdminWorkflowsWorkflowIdRoute
  '/notes/$ref/{-$slug}': typeof AppNotesRefChar123SlugChar125Route
  '/p/$productKey/board': typeof AppPProductKeyBoardRoute
  '/p/$productKey/fields': typeof AppPProductKeyFieldsRoute
  '/p/$productKey/list': typeof AppPProductKeyListRoute
  '/p/$productKey/next-up': typeof AppPProductKeyNextUpRoute
  '/p/$productKey/timeline': typeof AppPProductKeyTimelineRoute
  '/p/$productKey/trash': typeof AppPProductKeyTrashRoute
  '/p/$productKey/views': typeof AppPProductKeyViewsRoute
  '/admin/workflows': typeof AppAdminWorkflowsIndexRoute
  '/p/$productKey': typeof AppPProductKeyIndexRoute
  '/p/$productKey/milestones/$milestoneId': typeof AppPProductKeyMilestonesMilestoneIdRoute
  '/p/$productKey/milestones': typeof AppPProductKeyMilestonesIndexRoute
  '/p/$productKey/notes': typeof AppPProductKeyNotesIndexRoute
  '/p/$productKey/notes/$ref/{-$slug}': typeof AppPProductKeyNotesRefChar123SlugChar125Route
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/setup': typeof SetupRoute
  '/two-factor-setup': typeof TwoFactorSetupRoute
  '/_app/$itemKey': typeof AppItemKeyRoute
  '/_app/admin': typeof AppAdminRouteWithChildren
  '/_app/feedback': typeof AppFeedbackRoute
  '/_app/inbox': typeof AppInboxRoute
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_app/triage': typeof AppTriageRoute
  '/dev/design': typeof DevDesignRoute
  '/f/$token': typeof FTokenRoute
  '/invite/$token': typeof InviteTokenRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/_app/': typeof AppIndexRoute
  '/_app/admin/access': typeof AppAdminAccessRoute
  '/_app/admin/audit': typeof AppAdminAuditRoute
  '/_app/admin/authentication': typeof AppAdminAuthenticationRoute
  '/_app/admin/fields': typeof AppAdminFieldsRoute
  '/_app/admin/github': typeof AppAdminGithubRoute
  '/_app/admin/groups': typeof AppAdminGroupsRoute
  '/_app/admin/instance': typeof AppAdminInstanceRoute
  '/_app/admin/invites': typeof AppAdminInvitesRoute
  '/_app/admin/license': typeof AppAdminLicenseRoute
  '/_app/admin/roles': typeof AppAdminRolesRoute
  '/_app/admin/system': typeof AppAdminSystemRoute
  '/_app/admin/translation': typeof AppAdminTranslationRoute
  '/_app/admin/types': typeof AppAdminTypesRoute
  '/_app/admin/users': typeof AppAdminUsersRoute
  '/_app/admin/webhooks': typeof AppAdminWebhooksRoute
  '/_app/dev/perf': typeof AppDevPerfRoute
  '/_app/p/$productKey': typeof AppPProductKeyRouteWithChildren
  '/_app/s/$spaceKey': typeof AppSSpaceKeyRoute
  '/_app/settings/claude': typeof AppSettingsClaudeRoute
  '/_app/settings/notifications': typeof AppSettingsNotificationsRoute
  '/_app/settings/security': typeof AppSettingsSecurityRoute
  '/_app/settings/tokens': typeof AppSettingsTokensRoute
  '/_app/admin/': typeof AppAdminIndexRoute
  '/_app/notes/': typeof AppNotesIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/admin/workflows/$workflowId': typeof AppAdminWorkflowsWorkflowIdRoute
  '/_app/notes/$ref/{-$slug}': typeof AppNotesRefChar123SlugChar125Route
  '/_app/p/$productKey/board': typeof AppPProductKeyBoardRoute
  '/_app/p/$productKey/fields': typeof AppPProductKeyFieldsRoute
  '/_app/p/$productKey/list': typeof AppPProductKeyListRoute
  '/_app/p/$productKey/next-up': typeof AppPProductKeyNextUpRoute
  '/_app/p/$productKey/timeline': typeof AppPProductKeyTimelineRoute
  '/_app/p/$productKey/trash': typeof AppPProductKeyTrashRoute
  '/_app/p/$productKey/views': typeof AppPProductKeyViewsRoute
  '/_app/admin/workflows/': typeof AppAdminWorkflowsIndexRoute
  '/_app/p/$productKey/': typeof AppPProductKeyIndexRoute
  '/_app/p/$productKey/milestones/$milestoneId': typeof AppPProductKeyMilestonesMilestoneIdRoute
  '/_app/p/$productKey/milestones/': typeof AppPProductKeyMilestonesIndexRoute
  '/_app/p/$productKey/notes/': typeof AppPProductKeyNotesIndexRoute
  '/_app/p/$productKey/notes/$ref/{-$slug}': typeof AppPProductKeyNotesRefChar123SlugChar125Route
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/setup'
    | '/two-factor-setup'
    | '/$itemKey'
    | '/admin'
    | '/feedback'
    | '/inbox'
    | '/settings'
    | '/triage'
    | '/dev/design'
    | '/f/$token'
    | '/invite/$token'
    | '/reset-password/$token'
    | '/admin/access'
    | '/admin/audit'
    | '/admin/authentication'
    | '/admin/fields'
    | '/admin/github'
    | '/admin/groups'
    | '/admin/instance'
    | '/admin/invites'
    | '/admin/license'
    | '/admin/roles'
    | '/admin/system'
    | '/admin/translation'
    | '/admin/types'
    | '/admin/users'
    | '/admin/webhooks'
    | '/dev/perf'
    | '/p/$productKey'
    | '/s/$spaceKey'
    | '/settings/claude'
    | '/settings/notifications'
    | '/settings/security'
    | '/settings/tokens'
    | '/admin/'
    | '/notes/'
    | '/settings/'
    | '/admin/workflows/$workflowId'
    | '/notes/$ref/{-$slug}'
    | '/p/$productKey/board'
    | '/p/$productKey/fields'
    | '/p/$productKey/list'
    | '/p/$productKey/next-up'
    | '/p/$productKey/timeline'
    | '/p/$productKey/trash'
    | '/p/$productKey/views'
    | '/admin/workflows/'
    | '/p/$productKey/'
    | '/p/$productKey/milestones/$milestoneId'
    | '/p/$productKey/milestones/'
    | '/p/$productKey/notes/'
    | '/p/$productKey/notes/$ref/{-$slug}'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/setup'
    | '/two-factor-setup'
    | '/$itemKey'
    | '/feedback'
    | '/inbox'
    | '/triage'
    | '/dev/design'
    | '/f/$token'
    | '/invite/$token'
    | '/reset-password/$token'
    | '/'
    | '/admin/access'
    | '/admin/audit'
    | '/admin/authentication'
    | '/admin/fields'
    | '/admin/github'
    | '/admin/groups'
    | '/admin/instance'
    | '/admin/invites'
    | '/admin/license'
    | '/admin/roles'
    | '/admin/system'
    | '/admin/translation'
    | '/admin/types'
    | '/admin/users'
    | '/admin/webhooks'
    | '/dev/perf'
    | '/s/$spaceKey'
    | '/settings/claude'
    | '/settings/notifications'
    | '/settings/security'
    | '/settings/tokens'
    | '/admin'
    | '/notes'
    | '/settings'
    | '/admin/workflows/$workflowId'
    | '/notes/$ref/{-$slug}'
    | '/p/$productKey/board'
    | '/p/$productKey/fields'
    | '/p/$productKey/list'
    | '/p/$productKey/next-up'
    | '/p/$productKey/timeline'
    | '/p/$productKey/trash'
    | '/p/$productKey/views'
    | '/admin/workflows'
    | '/p/$productKey'
    | '/p/$productKey/milestones/$milestoneId'
    | '/p/$productKey/milestones'
    | '/p/$productKey/notes'
    | '/p/$productKey/notes/$ref/{-$slug}'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/setup'
    | '/two-factor-setup'
    | '/_app/$itemKey'
    | '/_app/admin'
    | '/_app/feedback'
    | '/_app/inbox'
    | '/_app/settings'
    | '/_app/triage'
    | '/dev/design'
    | '/f/$token'
    | '/invite/$token'
    | '/reset-password/$token'
    | '/_app/'
    | '/_app/admin/access'
    | '/_app/admin/audit'
    | '/_app/admin/authentication'
    | '/_app/admin/fields'
    | '/_app/admin/github'
    | '/_app/admin/groups'
    | '/_app/admin/instance'
    | '/_app/admin/invites'
    | '/_app/admin/license'
    | '/_app/admin/roles'
    | '/_app/admin/system'
    | '/_app/admin/translation'
    | '/_app/admin/types'
    | '/_app/admin/users'
    | '/_app/admin/webhooks'
    | '/_app/dev/perf'
    | '/_app/p/$productKey'
    | '/_app/s/$spaceKey'
    | '/_app/settings/claude'
    | '/_app/settings/notifications'
    | '/_app/settings/security'
    | '/_app/settings/tokens'
    | '/_app/admin/'
    | '/_app/notes/'
    | '/_app/settings/'
    | '/_app/admin/workflows/$workflowId'
    | '/_app/notes/$ref/{-$slug}'
    | '/_app/p/$productKey/board'
    | '/_app/p/$productKey/fields'
    | '/_app/p/$productKey/list'
    | '/_app/p/$productKey/next-up'
    | '/_app/p/$productKey/timeline'
    | '/_app/p/$productKey/trash'
    | '/_app/p/$productKey/views'
    | '/_app/admin/workflows/'
    | '/_app/p/$productKey/'
    | '/_app/p/$productKey/milestones/$milestoneId'
    | '/_app/p/$productKey/milestones/'
    | '/_app/p/$productKey/notes/'
    | '/_app/p/$productKey/notes/$ref/{-$slug}'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  SetupRoute: typeof SetupRoute
  TwoFactorSetupRoute: typeof TwoFactorSetupRoute
  DevDesignRoute: typeof DevDesignRoute
  FTokenRoute: typeof FTokenRoute
  InviteTokenRoute: typeof InviteTokenRoute
  ResetPasswordTokenRoute: typeof ResetPasswordTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/two-factor-setup': {
      id: '/two-factor-setup'
      path: '/two-factor-setup'
      fullPath: '/two-factor-setup'
      preLoaderRoute: typeof TwoFactorSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/$itemKey': {
      id: '/_app/$itemKey'
      path: '/$itemKey'
      fullPath: '/$itemKey'
      preLoaderRoute: typeof AppItemKeyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/feedback': {
      id: '/_app/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof AppFeedbackRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox': {
      id: '/_app/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AppInboxRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/triage': {
      id: '/_app/triage'
      path: '/triage'
      fullPath: '/triage'
      preLoaderRoute: typeof AppTriageRouteImport
      parentRoute: typeof AppRoute
    }
    '/dev/design': {
      id: '/dev/design'
      path: '/dev/design'
      fullPath: '/dev/design'
      preLoaderRoute: typeof DevDesignRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/f/$token': {
      id: '/f/$token'
      path: '/f/$token'
      fullPath: '/f/$token'
      preLoaderRoute: typeof FTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password/$token': {
      id: '/reset-password/$token'
      path: '/reset-password/$token'
      fullPath: '/reset-password/$token'
      preLoaderRoute: typeof ResetPasswordTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/access': {
      id: '/_app/admin/access'
      path: '/access'
      fullPath: '/admin/access'
      preLoaderRoute: typeof AppAdminAccessRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/audit': {
      id: '/_app/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AppAdminAuditRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/authentication': {
      id: '/_app/admin/authentication'
      path: '/authentication'
      fullPath: '/admin/authentication'
      preLoaderRoute: typeof AppAdminAuthenticationRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/fields': {
      id: '/_app/admin/fields'
      path: '/fields'
      fullPath: '/admin/fields'
      preLoaderRoute: typeof AppAdminFieldsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/github': {
      id: '/_app/admin/github'
      path: '/github'
      fullPath: '/admin/github'
      preLoaderRoute: typeof AppAdminGithubRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/groups': {
      id: '/_app/admin/groups'
      path: '/groups'
      fullPath: '/admin/groups'
      preLoaderRoute: typeof AppAdminGroupsRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/instance': {
      id: '/_app/admin/instance'
      path: '/instance'
      fullPath: '/admin/instance'
      preLoaderRoute: typeof AppAdminInstanceRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/invites': {
      id: '/_app/admin/invites'
      path: '/invites'
      fullPath: '/admin/invites'
      preLoaderRoute: typeof AppAdminInvitesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/license': {
      id: '/_app/admin/license'
      path: '/license'
      fullPath: '/admin/license'
      preLoaderRoute: typeof AppAdminLicenseRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/roles': {
      id: '/_app/admin/roles'
      path: '/roles'
      fullPath: '/admin/roles'
      preLoaderRoute: typeof AppAdminRolesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/system': {
      id: '/_app/admin/system'
      path: '/system'
      fullPath: '/admin/system'
      preLoaderRoute: typeof AppAdminSystemRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/translation': {
      id: '/_app/admin/translation'
      path: '/translation'
      fullPath: '/admin/translation'
      preLoaderRoute: typeof AppAdminTranslationRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/types': {
      id: '/_app/admin/types'
      path: '/types'
      fullPath: '/admin/types'
      preLoaderRoute: typeof AppAdminTypesRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/users': {
      id: '/_app/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AppAdminUsersRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/webhooks': {
      id: '/_app/admin/webhooks'
      path: '/webhooks'
      fullPath: '/admin/webhooks'
      preLoaderRoute: typeof AppAdminWebhooksRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/dev/perf': {
      id: '/_app/dev/perf'
      path: '/dev/perf'
      fullPath: '/dev/perf'
      preLoaderRoute: typeof AppDevPerfRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notes/': {
      id: '/_app/notes/'
      path: '/notes'
      fullPath: '/notes/'
      preLoaderRoute: typeof AppNotesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/p/$productKey': {
      id: '/_app/p/$productKey'
      path: '/p/$productKey'
      fullPath: '/p/$productKey'
      preLoaderRoute: typeof AppPProductKeyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/s/$spaceKey': {
      id: '/_app/s/$spaceKey'
      path: '/s/$spaceKey'
      fullPath: '/s/$spaceKey'
      preLoaderRoute: typeof AppSSpaceKeyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/claude': {
      id: '/_app/settings/claude'
      path: '/claude'
      fullPath: '/settings/claude'
      preLoaderRoute: typeof AppSettingsClaudeRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/notifications': {
      id: '/_app/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AppSettingsNotificationsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/security': {
      id: '/_app/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AppSettingsSecurityRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/tokens': {
      id: '/_app/settings/tokens'
      path: '/tokens'
      fullPath: '/settings/tokens'
      preLoaderRoute: typeof AppSettingsTokensRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/admin/workflows/': {
      id: '/_app/admin/workflows/'
      path: '/workflows'
      fullPath: '/admin/workflows/'
      preLoaderRoute: typeof AppAdminWorkflowsIndexRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/admin/workflows/$workflowId': {
      id: '/_app/admin/workflows/$workflowId'
      path: '/workflows/$workflowId'
      fullPath: '/admin/workflows/$workflowId'
      preLoaderRoute: typeof AppAdminWorkflowsWorkflowIdRouteImport
      parentRoute: typeof AppAdminRoute
    }
    '/_app/notes/$ref/{-$slug}': {
      id: '/_app/notes/$ref/{-$slug}'
      path: '/notes/$ref/{-$slug}'
      fullPath: '/notes/$ref/{-$slug}'
      preLoaderRoute: typeof AppNotesRefChar123SlugChar125RouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/p/$productKey/': {
      id: '/_app/p/$productKey/'
      path: '/'
      fullPath: '/p/$productKey/'
      preLoaderRoute: typeof AppPProductKeyIndexRouteImport
      parentRoute: typeof AppPProductKeyRoute
    }
    '/_app/p/$productKey/board': {
      id: '/_app/p/$productKey/board'
      path: '/board'
      fullPath: '/p/$productKey/board'
      preLoaderRoute: typeof AppPProductKeyBoardRouteImport
      parentRoute: typeof AppPProductKeyRoute
    }
    '/_app/p/$productKey/fields': {
      id: '/_app/p/$productKey/fields'
      path: '/fields'
      fullPath: '/p/$productKey/fields'
      preLoaderRoute: typeof AppPProductKeyFieldsRouteImport
      parentRoute: typeof AppPProductKeyRoute
    }
    '/_app/p/$productKey/list': {
      id: '/_app/p/$productKey/list'
      path: '/list'
      fullPath: '/p/$productKey/list'
      preLoaderRoute: typeof AppPProductKeyListRouteImport
      parentRoute: typeof AppPProductKeyRoute
    }
    '/_app/p/$productKey/next-up': {
      id: '/_app/p/$productKey/next-up'
      path: '/next-up'
      fullPath: '/p/$productKey/next-up'
      preLoaderRoute: typeof AppPProductKeyNextUpRouteImport
      parentRoute: typeof AppPProductKeyRoute
    }
    '/_app/p/$productKey/timeline': {
      id: '/_app/p/$productKey/timeline'
      path: '/timeline'
      fullPath: '/p/$productKey/timeline'
      preLoaderRoute: typeof AppPProductKeyTimelineRouteImport
      parentRoute: typeof AppPProductKeyRoute
    }
    '/_app/p/$productKey/trash': {
      id: '/_app/p/$productKey/trash'
      path: '/trash'
      fullPath: '/p/$productKey/trash'
      preLoaderRoute: typeof AppPProductKeyTrashRouteImport
      parentRoute: typeof AppPProductKeyRoute
    }
    '/_app/p/$productKey/views': {
      id: '/_app/p/$productKey/views'
      path: '/views'
      fullPath: '/p/$productKey/views'
      preLoaderRoute: typeof AppPProductKeyViewsRouteImport
      parentRoute: typeof AppPProductKeyRoute
    }
    '/_app/p/$productKey/milestones/': {
      id: '/_app/p/$productKey/milestones/'
      path: '/milestones'
      fullPath: '/p/$productKey/milestones/'
      preLoaderRoute: typeof AppPProductKeyMilestonesIndexRouteImport
      parentRoute: typeof AppPProductKeyRoute
    }
    '/_app/p/$productKey/milestones/$milestoneId': {
      id: '/_app/p/$productKey/milestones/$milestoneId'
      path: '/milestones/$milestoneId'
      fullPath: '/p/$productKey/milestones/$milestoneId'
      preLoaderRoute: typeof AppPProductKeyMilestonesMilestoneIdRouteImport
      parentRoute: typeof AppPProductKeyRoute
    }
    '/_app/p/$productKey/notes/': {
      id: '/_app/p/$productKey/notes/'
      path: '/notes'
      fullPath: '/p/$productKey/notes/'
      preLoaderRoute: typeof AppPProductKeyNotesIndexRouteImport
      parentRoute: typeof AppPProductKeyRoute
    }
    '/_app/p/$productKey/notes/$ref/{-$slug}': {
      id: '/_app/p/$productKey/notes/$ref/{-$slug}'
      path: '/notes/$ref/{-$slug}'
      fullPath: '/p/$productKey/notes/$ref/{-$slug}'
      preLoaderRoute: typeof AppPProductKeyNotesRefChar123SlugChar125RouteImport
      parentRoute: typeof AppPProductKeyRoute
    }
  }
}

interface AppAdminRouteChildren {
  AppAdminAccessRoute: typeof AppAdminAccessRoute
  AppAdminAuditRoute: typeof AppAdminAuditRoute
  AppAdminAuthenticationRoute: typeof AppAdminAuthenticationRoute
  AppAdminFieldsRoute: typeof AppAdminFieldsRoute
  AppAdminGithubRoute: typeof AppAdminGithubRoute
  AppAdminGroupsRoute: typeof AppAdminGroupsRoute
  AppAdminInstanceRoute: typeof AppAdminInstanceRoute
  AppAdminInvitesRoute: typeof AppAdminInvitesRoute
  AppAdminLicenseRoute: typeof AppAdminLicenseRoute
  AppAdminRolesRoute: typeof AppAdminRolesRoute
  AppAdminSystemRoute: typeof AppAdminSystemRoute
  AppAdminTranslationRoute: typeof AppAdminTranslationRoute
  AppAdminTypesRoute: typeof AppAdminTypesRoute
  AppAdminUsersRoute: typeof AppAdminUsersRoute
  AppAdminWebhooksRoute: typeof AppAdminWebhooksRoute
  AppAdminIndexRoute: typeof AppAdminIndexRoute
  AppAdminWorkflowsWorkflowIdRoute: typeof AppAdminWorkflowsWorkflowIdRoute
  AppAdminWorkflowsIndexRoute: typeof AppAdminWorkflowsIndexRoute
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminAccessRoute: AppAdminAccessRoute,
  AppAdminAuditRoute: AppAdminAuditRoute,
  AppAdminAuthenticationRoute: AppAdminAuthenticationRoute,
  AppAdminFieldsRoute: AppAdminFieldsRoute,
  AppAdminGithubRoute: AppAdminGithubRoute,
  AppAdminGroupsRoute: AppAdminGroupsRoute,
  AppAdminInstanceRoute: AppAdminInstanceRoute,
  AppAdminInvitesRoute: AppAdminInvitesRoute,
  AppAdminLicenseRoute: AppAdminLicenseRoute,
  AppAdminRolesRoute: AppAdminRolesRoute,
  AppAdminSystemRoute: AppAdminSystemRoute,
  AppAdminTranslationRoute: AppAdminTranslationRoute,
  AppAdminTypesRoute: AppAdminTypesRoute,
  AppAdminUsersRoute: AppAdminUsersRoute,
  AppAdminWebhooksRoute: AppAdminWebhooksRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
  AppAdminWorkflowsWorkflowIdRoute: AppAdminWorkflowsWorkflowIdRoute,
  AppAdminWorkflowsIndexRoute: AppAdminWorkflowsIndexRoute,
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
)

interface AppSettingsRouteChildren {
  AppSettingsClaudeRoute: typeof AppSettingsClaudeRoute
  AppSettingsNotificationsRoute: typeof AppSettingsNotificationsRoute
  AppSettingsSecurityRoute: typeof AppSettingsSecurityRoute
  AppSettingsTokensRoute: typeof AppSettingsTokensRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsClaudeRoute: AppSettingsClaudeRoute,
  AppSettingsNotificationsRoute: AppSettingsNotificationsRoute,
  AppSettingsSecurityRoute: AppSettingsSecurityRoute,
  AppSettingsTokensRoute: AppSettingsTokensRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppPProductKeyRouteChildren {
  AppPProductKeyBoardRoute: typeof AppPProductKeyBoardRoute
  AppPProductKeyFieldsRoute: typeof AppPProductKeyFieldsRoute
  AppPProductKeyListRoute: typeof AppPProductKeyListRoute
  AppPProductKeyNextUpRoute: typeof AppPProductKeyNextUpRoute
  AppPProductKeyTimelineRoute: typeof AppPProductKeyTimelineRoute
  AppPProductKeyTrashRoute: typeof AppPProductKeyTrashRoute
  AppPProductKeyViewsRoute: typeof AppPProductKeyViewsRoute
  AppPProductKeyIndexRoute: typeof AppPProductKeyIndexRoute
  AppPProductKeyMilestonesMilestoneIdRoute: typeof AppPProductKeyMilestonesMilestoneIdRoute
  AppPProductKeyMilestonesIndexRoute: typeof AppPProductKeyMilestonesIndexRoute
  AppPProductKeyNotesIndexRoute: typeof AppPProductKeyNotesIndexRoute
  AppPProductKeyNotesRefChar123SlugChar125Route: typeof AppPProductKeyNotesRefChar123SlugChar125Route
}

const AppPProductKeyRouteChildren: AppPProductKeyRouteChildren = {
  AppPProductKeyBoardRoute: AppPProductKeyBoardRoute,
  AppPProductKeyFieldsRoute: AppPProductKeyFieldsRoute,
  AppPProductKeyListRoute: AppPProductKeyListRoute,
  AppPProductKeyNextUpRoute: AppPProductKeyNextUpRoute,
  AppPProductKeyTimelineRoute: AppPProductKeyTimelineRoute,
  AppPProductKeyTrashRoute: AppPProductKeyTrashRoute,
  AppPProductKeyViewsRoute: AppPProductKeyViewsRoute,
  AppPProductKeyIndexRoute: AppPProductKeyIndexRoute,
  AppPProductKeyMilestonesMilestoneIdRoute:
    AppPProductKeyMilestonesMilestoneIdRoute,
  AppPProductKeyMilestonesIndexRoute: AppPProductKeyMilestonesIndexRoute,
  AppPProductKeyNotesIndexRoute: AppPProductKeyNotesIndexRoute,
  AppPProductKeyNotesRefChar123SlugChar125Route:
    AppPProductKeyNotesRefChar123SlugChar125Route,
}

const AppPProductKeyRouteWithChildren = AppPProductKeyRoute._addFileChildren(
  AppPProductKeyRouteChildren,
)

interface AppRouteChildren {
  AppItemKeyRoute: typeof AppItemKeyRoute
  AppAdminRoute: typeof AppAdminRouteWithChildren
  AppFeedbackRoute: typeof AppFeedbackRoute
  AppInboxRoute: typeof AppInboxRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppTriageRoute: typeof AppTriageRoute
  AppIndexRoute: typeof AppIndexRoute
  AppDevPerfRoute: typeof AppDevPerfRoute
  AppPProductKeyRoute: typeof AppPProductKeyRouteWithChildren
  AppSSpaceKeyRoute: typeof AppSSpaceKeyRoute
  AppNotesIndexRoute: typeof AppNotesIndexRoute
  AppNotesRefChar123SlugChar125Route: typeof AppNotesRefChar123SlugChar125Route
}

const AppRouteChildren: AppRouteChildren = {
  AppItemKeyRoute: AppItemKeyRoute,
  AppAdminRoute: AppAdminRouteWithChildren,
  AppFeedbackRoute: AppFeedbackRoute,
  AppInboxRoute: AppInboxRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppTriageRoute: AppTriageRoute,
  AppIndexRoute: AppIndexRoute,
  AppDevPerfRoute: AppDevPerfRoute,
  AppPProductKeyRoute: AppPProductKeyRouteWithChildren,
  AppSSpaceKeyRoute: AppSSpaceKeyRoute,
  AppNotesIndexRoute: AppNotesIndexRoute,
  AppNotesRefChar123SlugChar125Route: AppNotesRefChar123SlugChar125Route,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  SetupRoute: SetupRoute,
  TwoFactorSetupRoute: TwoFactorSetupRoute,
  DevDesignRoute: DevDesignRoute,
  FTokenRoute: FTokenRoute,
  InviteTokenRoute: InviteTokenRoute,
  ResetPasswordTokenRoute: ResetPasswordTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
